export const DEFAULT_ROUTE_PATH = "/tel-aviv-university/MBA/Management";
export const TAU_MASTERS_FACULTY_PATH = DEFAULT_ROUTE_PATH;

export function normalizePath(pathname = "/") {
  const clean = String(pathname || "/").replace(/\/+$/, "");
  return clean || "/";
}

export function previewQueryPath() {
  if (typeof window === "undefined") return "";
  try {
    const raw = new URLSearchParams(window.location.search).get("preview") || "";
    if (!raw.trim()) return "";
    const withSlash = raw.startsWith("/") ? raw : `/${raw}`;
    return normalizePath(withSlash);
  } catch {
    return "";
  }
}

export function currentLocationPath() {
  if (typeof window === "undefined") return "/";
  return previewQueryPath() || normalizePath(window.location.pathname);
}

export function canonicalPath() {
  return `${TAU_MASTERS_FACULTY_PATH}/`;
}
